import '.a{display:flex;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.bb{gap:0.5rem;}.ssr-plugin'
import '.ba{cursor:pointer;}.ssr-plugin'
import '.i8{padding:0.75rem;}.ssr-plugin'
import '.ar{border-radius:1.25rem;}.ssr-plugin'
import '.bc{border:var(--blue-border);}.ssr-plugin'
import '.as{background-color:var(--shades-white);}.ssr-plugin'
import '.d3{transition:background-color 0.2s ease;}.ssr-plugin'
import '.dk{width:2.5rem;}.ssr-plugin'
import '.dl{height:2.5rem;}.ssr-plugin'
import '.i9{color:var(--shades-blue-700);}.ssr-plugin'
import '.ia{font-size:0.9rem;}.ssr-plugin'
import '.ak{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a g b c bb ba i8 ar bc as d3"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="dk dl a c g i9"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="ia i9 ak"
        >
          {label}
        </span>
      </styled.button>
    )
}